import { render, staticRenderFns } from "./updatePermissionPossession.vue?vue&type=template&id=0a01b298&"
import script from "./updatePermissionPossession.vue?vue&type=script&lang=js&"
export * from "./updatePermissionPossession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports